import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { AlloyButton, InfoIcon } from 'cat-ecommerce-alloy';
import CoreDepositPopup from '@app/components/common/CoreDepositPopup';
import styles from '@app/components/pages/summary-and-payment/styles.module.scss';

const ItemsInOrderTableCoreDepositPopup = () => {
  const [t] = useTranslation();

  const initiator = (
    <AlloyButton
      buttonType="link"
      className={cx('p-0 text-nowrap text-xs d-inline-flex align-items-center')}
    >
      <InfoIcon
        width={16}
        height={16}
        className="u-fill--DarkGray me-1 d-print-none"
      />
      <div className={styles['print-on-black']}>
        {t('CAT_CORE_DEPOSIT_LABEL')}
      </div>
    </AlloyButton>
  );
  return <CoreDepositPopup initiator={initiator} />;
};

export default ItemsInOrderTableCoreDepositPopup;
